/**
 * @file Network status composable for tracking online/offline state
 * @since 2025-10-04
 */

const { ref, onMounted, onUnmounted } = Vue;

let isOnline = null;
let listeners = [];

// Singleton reactive instance
let reactiveInstance = null;

/**
 * Composable for tracking network online/offline status
 * @returns {object} Reactive network status
 */
export function useNetworkStatus() {
  // Initialize singleton on first use
  if (reactiveInstance === null) {
    isOnline = ref(navigator.onLine);

    const updateOnlineStatus = () => {
      isOnline.value = navigator.onLine;
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Store cleanup function
    listeners.push(() => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    });

    // Create reactive singleton instance
    reactiveInstance = Vue.reactive({
      isOnline,
    });
  }

  return reactiveInstance;
}

/**
 * Cleanup function for tests
 * @private
 */
export function _cleanup() {
  listeners.forEach(fn => fn());
  listeners = [];
  isOnline = null;
  reactiveInstance = null;
}
